// extracted by mini-css-extract-plugin
export var footer = "layout-module--footer--14vHc";
export var footerEmail = "layout-module--footer-email--pSWch";
export var footerRights = "layout-module--footer-rights--3zBrf";